import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { TaskTypeType } from '../../../../../../store/api/tasks-api';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { taskTypeMap } from '../../../tasks/use-task-list';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { withBarSelection } from '../../dashboard-helpers';

interface DataType {
  values?: {
    name: TaskTypeType;
    data: number[];
  }[];
  dates?: string[];
}

export const useTasksCategoriesOverTime = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.total_tasks_by_category_in_time as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      let isDataExist = false;

      for (const value of data.values ?? []) {
        value.name = t(taskTypeMap[value.name]);

        if (!isDataExist) {
          isDataExist = value.data.some((count) => count > 0);
        }
      }

      return {
        series: isDataExist ? data.values : [],
        options: {
          chart: {
            type: 'bar',
            stacked: true,
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: 'left',
            position: 'top',
            markers: {
              shape: 'circle',
              size: 4,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 4,
              hideZeroBarsWhenGrouped: true,
              borderRadiusApplication: 'end',
              borderRadiusWhenStacked: 'last',
            },
          },
          xaxis: {
            categories: data.dates,
            axisTicks: { show: false },
            tickAmount: 10,
          },
          yaxis: {},
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            shared: true,
            intersect: false,
            hideEmptySeries: true,
            inverseOrder: true,
          },
          colors: ['#CB3CFF', '#0E43FB', '#00C2FF'],
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [t, data]);

  return {
    series: chartData.series,
    options: withBarSelection(chartData).options,
    label: 'Количество задач по категориям во времени',
    subLabel:
      'График отражает, как меняется количество задач в разных категориях, упрощая анализ тенденций и выявление наиболее загруженных направлений',
    type: 'bar',
    wrapped: true,
  };
};
